import Grid from "@mui/material/Grid";
import React from "react";
import useWindowSize from "../../../utility/useWindowSize";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import {CmCollectionType} from "../../types";
import C086DonationCardTeaser from "./C086DonationCardTeaser";


interface Props {
    cmCollection: CmCollectionType;
}

function C086DonationCardTeaserContainer(props: Props) {
    const {lowerThanWindowMedium} = useWindowSize();
    const items = props.cmCollection.items?.slice(0, 3);
    const itemWidth = items?.length === 3 ? 4 : items?.length === 2 ? 6 : 12;

    function prepareItems(collectionItems: Array<any>) {
        const preparedItems: Array<any> = [];
        collectionItems.slice(0, 3).map((item: any, index: number) => {
            preparedItems.push(
                <Grid size={{md: 12, lg: itemWidth, xl: itemWidth}} key={index}
                      data-cypress={`donation-card-item-${index}`}>
                    <C086DonationCardTeaser item={item} horizontal={collectionItems.length === 1 &&
                                                                    !lowerThanWindowMedium}/>
                </Grid>
            );
        });
        return preparedItems;
    }

    return (
        <CCOComponentWrapper background='grey' dataCypress='donation-card-teaser-container'>
            <CCOHeadline id={props.cmCollection.id}
                         metadataId={props.cmCollection.id}
                         propertyName='properties.teaserTitle'
                         subtextPropertyName='properties.teaserText'
                         headline={props.cmCollection.teaserTitle}
                         type='componenthead'
                         subtext={props.cmCollection.teaserText?.textAsTree}
                         background='grey'/>
            <CCOContainer background='grey' width='large'>
                <Grid container spacing={6} sx={{
                    mt: 10
                }}>
                    {prepareItems(items!)}
                </Grid>

            </CCOContainer>
        </CCOComponentWrapper>
    );
}

export default C086DonationCardTeaserContainer;